import * as Domain from './domain';

export const examPlayerModules = [
  Domain.examPlayerModule
]
